import { render } from "./input-item.vue?vue&type=template&id=4a2172f7"
import script from "./input-item.vue?vue&type=script&lang=js"
export * from "./input-item.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/input-item.vue'],['render',render],['__file',"input-item.vue"]])

export default __exports__